import { LengthTokenValue } from 'designSystem/types';
import * as S from './styles';

interface SpacingTokenPreviewProps {
	value: LengthTokenValue;
}

export const SpacingTokenPreview = ({ value }: SpacingTokenPreviewProps) => {
	const spacing = value.px || value.numericValue * 16;
	const displayValue = value.px !== undefined ? `${value.px}px` : value.original;

	return (
		<S.PreviewContainer>
			<S.BoxPaddingHorizontal3>
				<S.SpacingBoxLeft spacing={spacing} />
				<S.FixedBox />
				<S.SpacingBoxRight spacing={spacing} />
			</S.BoxPaddingHorizontal3>
			<S.ValueText>{displayValue}</S.ValueText>
		</S.PreviewContainer>
	);
};
